/**
 * Lightweight assertion helpers mirroring Node's `assert` module for browser use.
 */

const createError = (message?: string): Error => {
  return new Error(message ?? 'Assertion failed');
};

export const ok = (value: unknown, message?: string): void => {
  if (!value) {
    throw createError(message);
  }
};

export const fail = (message?: string): never => {
  throw createError(message);
};

export const strictEqual = (actual: unknown, expected: unknown, message?: string): void => {
  if (actual !== expected) {
    throw createError(message ?? `Expected ${actual} to strictly equal ${expected}`);
  }
};

export const deepStrictEqual = (actual: unknown, expected: unknown, message?: string): void => {
  const pass = JSON.stringify(actual) === JSON.stringify(expected);
  if (!pass) {
    throw createError(message ?? 'Deep strict equality assertion failed');
  }
};

export default {
  ok,
  fail,
  strictEqual,
  deepStrictEqual,
};
